/* eslint-disable @typescript-eslint/no-explicit-any */
import api from 'libs/axios/api';
import { BASE_URL } from 'libs/axios/axiosInstance';
import { apiService } from 'libs/axios/services';
import { QR_TYPE } from 'utils/enums';

export const getListUserFetcher = async (
    params: URLSearchParams,
): Promise<ApiResponse<IGetListUserRes>> => {
    return apiService.get<URLSearchParams, IGetListUserRes>(
        `${BASE_URL}/user/list`,
        params,
        undefined,
        true,
    );
};

export const getCompanyOptionsFetcher = async (
    params: URLSearchParams,
): Promise<ApiResponse<IGetCompanyOptionsRes>> => {
    return apiService.get<URLSearchParams, IGetCompanyOptionsRes>(
        `${BASE_URL}/company/options`,
        params,
    );
};

export const getUserOptionsFetcher = async (
    params: UserOptionsRequest,
): Promise<ApiResponse<UserOptionsResponse>> => {
    return apiService.get<UserOptionsRequest, UserOptionsResponse>(
        `${BASE_URL}/user/options`,
        params,
    );
};

export const createUserFetcher = async (
    body: ICreateUserReq,
): Promise<ApiResponse<ICreateUpdateDeleteUserRes>> => {
    return apiService.post<ICreateUserReq, ICreateUpdateDeleteUserRes>(
        `${BASE_URL}/user/`,
        body,
        undefined,
        true,
    );
};

export const updateUserFetcher = async (
    id: string,
    body: ICreateUserReq,
): Promise<ApiResponse<ICreateUpdateDeleteUserRes>> => {
    return apiService.put<ICreateUserReq, ICreateUpdateDeleteUserRes>(
        `${BASE_URL}/user/${id}`,
        body,
        undefined,
        true,
    );
};

export const deleteUserFetcher = async (
    user_ids: string[],
): Promise<ApiResponse<ICreateUpdateDeleteUserRes>> => {
    const userIdsToDelete = { user_ids };
    return apiService.delete<typeof userIdsToDelete, ICreateUpdateDeleteUserRes>(
        `${BASE_URL}/user/list`,
        undefined,
        userIdsToDelete,
        undefined,
        true,
    );
};

export const updatePasswordUserFetcher = async (
    id: string,
    password: string,
): Promise<ApiResponse<ICreateUpdateDeleteUserRes>> => {
    const pwd = { password };
    return apiService.patch<typeof pwd, ICreateUpdateDeleteUserRes>(
        `${BASE_URL}/user/${id}/password-reissue`,
        pwd,
        undefined,
        true,
    );
};

export const userDownloadFetcher = async (request: URLSearchParams): Promise<ApiResponse<any>> => {
    return apiService.get<URLSearchParams, ResponseBase<any>>(api.userDownload, request, {
        responseType: 'blob',
    });
};

export const downloadQrUserFetcher = async (
    user_ids: string[],
    type: QR_TYPE,
): Promise<ApiResponse<any>> => {
    const userIds = { user_ids, type };
    return apiService.post<typeof userIds, any>(
        `${BASE_URL}/user/qrcode`,
        userIds,
        undefined,
        true,
    );
};
